import purchrAxios from './purchrAxios';

export default class SavedItemsService {
  static async all() {
    const response = await purchrAxios.get(`/savedItems`);
    return response.data;
  }

  static async getPaginated(params = {}) {
    const { page = 1, limit = 15, q = '', isActivated = false, tags = [] } = params;
    const queryParams = { page, limit };
    if (q) queryParams.q = q;
    if (isActivated) queryParams.isActivated = true;
    if (Array.isArray(tags) && tags.length) queryParams.tags = tags.join(',');

    const response = await purchrAxios.get(`/savedItems`, {
      params: queryParams
    });
    return response.data;
  }

  static async getTags() {
    const response = await purchrAxios.get(`/savedItems/tags`);
    return response.data;
  }

  static async delete(savedItemId) {
    const response = await purchrAxios.delete(`/savedItems/${savedItemId}`);
    return response.data;
  }

  static async update(savedItemId, objectToBeUpdated) {
    const response = await purchrAxios.put(
      `/savedItems/${savedItemId}`,
      { ...objectToBeUpdated },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }
}
